import { createURL } from 'Containers/Plans/utils';
import { PAYMENT_METHOD_MODAL } from 'Constants/modals';
import { FRONT_PLANS, PLAN_SHORT_NAME_DICTIONARY } from 'Constants/plans';
import { routes } from 'Constants/routes';
import { ResultType } from 'Types/common';

export interface YearsBannerProps {
  data?: ResultType;
  compensation?: boolean;
  isCompensationAndPay?: boolean;
  isForCompensation?: boolean;
}

export const proModalOptions = {
  type: PAYMENT_METHOD_MODAL,
  data: {
    plan: PLAN_SHORT_NAME_DICTIONARY[FRONT_PLANS.PRO],
    successUrl: createURL(routes.CHECKOUT_SUCCESS_STEP, {
      filing: 'true',
      plans: FRONT_PLANS.PRO,
      compensation: 'true',
    }),
    cancelUrl: createURL(routes.RESULT),
  },
};
